export enum FeatureFlagName {
  AUTH_2FA = "AUTH_2FA",
  RENOUVELLEMENT_AGREMENT = "RENOUVELLEMENT_AGREMENT",
  MODULE_SITE_UNITE_HEBERGEMENT = "MODULE_SITE_UNITE_HEBERGEMENT",
}
